import './download.scss'

import {LinkFileType} from 'campagne/types'
import React from 'react'
import {style} from 'util/campagne/style'
import {Theme} from 'views/campagne/theme'
import {ImageType} from 'campagne/types'

export type DownloadType = {
	title?: string
	files: Array<LinkFileType & ImageType>
}
const styles = style('download')

export const Download: React.FC<DownloadType> = ({title, files}) => {
	if (!files.length) return null
	return (
		<div class={styles}>
			{title && title !== '' && (
				<Theme.H5 className={styles('title')}>{title}</Theme.H5>
			)}
			<ul className={styles('files')}>
				{files.map((file) => {
					const hasUrl = !!file?.url
					const pathname = hasUrl ? file.url : file.src
					return (
						<li>
							<Theme.LinkDownload mod="small" to={pathname}>
								{file.description || file.title || file.alt}
							</Theme.LinkDownload>
						</li>
					)
				})}
			</ul>
		</div>
	)
}
